export const SAVE_COURSES = 'SAVE_COURSES';
export const SAVE_CURRENT_COURSE = 'SAVE_CURRENT_COURSE';